import StencilHTMLElement from "./stencil-element";

class ProductUpsell extends StencilHTMLElement {
  name = "Productupsell";
  variantId;
  quantity;
  properties;
  sellingPlanId;

  constructor() {
    super();
  }

  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.quantity = parseInt(this.dataset.quantity || '1');
    this.properties = this.getDecodedProperties();
    this.addEventListener('click', this.onProductUpsellAdd.bind(this));
    this.sellingPlanId = this.getSellingPlanId();
  }

  getDecodedProperties() {
    const propsEncoded = this.dataset.properties;
    if (!propsEncoded) return {};

    const properties = {};
    const propertiesArray = JSON.parse(atob(propsEncoded));
    propertiesArray.forEach(entry => {
      const [key, value] = entry.split("||||");
      if (key) properties[key] = value;
    });
    return properties;
  }

  getSellingPlanId() {
    const sellingPlanId = this.dataset.sellingPlanId;
    return sellingPlanId || null;
  }

  onProductUpsellAdd() {    
    const item = {
      id: this.variantId,
      quantity: this.quantity,
      properties: this.properties,
    };

    // Don't pass null selling plan
    if (this.sellingPlanId) {
      item.selling_plan = this.sellingPlanId;
    }

    try {
      MP.Extensions.Cart.add([item]);
    } catch(error) {
      MP.toast("warning", error, "fal fa-exclamation-triangle");
      console.error(this.logPrefix, "Error adding upsell product to cart:", error);
    }

  }
}

export default ProductUpsell;